<template>
  <div>
    <p class="title">
      {{ $t("eventWizard") }}
    </p>
    <GeneralInfo :editable="false" />
    <div class="py-6" />
    <Branding />
    <div class="py-6" />
  </div>
</template>

<script>
import { db } from "@/firebase";
import GeneralInfo from "@/components/eventWizard/GeneralInfo";
import Branding from "@/components/eventWizard/Branding";

export default {
  name: "EventWizardGeneralCard",
  components: {
    GeneralInfo,
    Branding,
  },
  props: {
    organizationId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      draftData: [],
      firestoreOrgData: [],
    };
  },
  watch: {
    // load in conditions data from firestore
    firestoreOrgData(firestoreOrgData) {
      if (firestoreOrgData != undefined) {
        this.conditions = firestoreOrgData.conditions;
      }
    },
    // load in data from firestore
    draftData(draft) {
      if (draft != null) {
        this.$store.commit("LOAD_DRAFT_DATA", draft);
      }
    },
    firestoreModerationPw(pw) {
      if (pw !== null) {
        if (pw.moderationPw !== null) {
          this.$store.commit("SET_MODERATION_PW", pw.moderationPw);
        }
      }
    },
  },
  methods: {
    // send back home without saving
    cancel() {
      this.$buefy.dialog.confirm({
        title: this.$t("eventWizardCancel"),
        message: this.$t("eventWizardCancelInfo"),
        confirmText: this.$t("eventWizardCancel"),
        type: "is-danger",
        closeOnConfirm: false,
        hasIcon: true,
        onConfirm: (component) => {
          component.close();
          this.$router.push({
            name: "Dashboard",
            params: { organizationId: this.organizationId },
          });
        },
      });
    },
  },
  firestore() {
    return {
      firestoreOrgData: db.collection("organizations").doc(this.organizationId),
      draftData: db.collection("organizations").doc(this.organizationId).collection("events").doc(this.eventId),
      firestoreModerationPw: db
        .collection("organizations")
        .doc(this.organizationId)
        .collection("events")
        .doc(this.eventId)
        .collection("data")
        .doc("moderationPw"),
    };
  },
};
</script>

<style>
.min-width-300 .dropdown-content {
  min-width: 300px;
}
</style>
